module.exports = __webpack_public_path__ + "static/media/appstore.43589f4f.svg";